const arrayOfCities = [
  {
    label: 'Akaa',
    value: 'Akaa'
  },
  {
    label: 'Alajärvi',
    value: 'Alajärvi'
  },
  {
    label: 'Alavieska',
    value: 'Alavieska'
  },
  {
    label: 'Alavus',
    value: 'Alavus'
  },
  {
    label: 'Asikkala',
    value: 'Asikkala'
  },
  {
    label: 'Askola',
    value: 'Askola'
  },
  {
    label: 'Aura',
    value: 'Aura'
  },
  {
    label: 'Brändö',
    value: 'Brändö'
  },
  {
    label: 'Eckerö',
    value: 'Eckerö'
  },
  {
    label: 'Enonkoski',
    value: 'Enonkoski'
  },
  {
    label: 'Enontekiö',
    value: 'Enontekiö'
  },
  {
    label: 'Espoo',
    value: 'Espoo'
  },
  {
    label: 'Eura',
    value: 'Eura'
  },
  {
    label: 'Eurajoki',
    value: 'Eurajoki'
  },
  {
    label: 'Evijärvi',
    value: 'Evijärvi'
  },
  {
    label: 'Finström',
    value: 'Finström'
  },
  {
    label: 'Forssa',
    value: 'Forssa'
  },
  {
    label: 'Föglö',
    value: 'Föglö'
  },
  {
    label: 'Geta',
    value: 'Geta'
  },
  {
    label: 'Haapajärvi',
    value: 'Haapajärvi'
  },
  {
    label: 'Haapavesi',
    value: 'Haapavesi'
  },
  {
    label: 'Hailuoto',
    value: 'Hailuoto'
  },
  {
    label: 'Halsua',
    value: 'Halsua'
  },
  {
    label: 'Hamina',
    value: 'Hamina'
  },
  {
    label: 'Hammarland',
    value: 'Hammarland'
  },
  {
    label: 'Hankasalmi',
    value: 'Hankasalmi'
  },
  {
    label: 'Hanko',
    value: 'Hanko'
  },
  {
    label: 'Harjavalta',
    value: 'Harjavalta'
  },
  {
    label: 'Hartola',
    value: 'Hartola'
  },
  {
    label: 'Hattula',
    value: 'Hattula'
  },
  {
    label: 'Hausjärvi',
    value: 'Hausjärvi'
  },
  {
    label: 'Heinola',
    value: 'Heinola'
  },
  {
    label: 'Heinävesi',
    value: 'Heinävesi'
  },
  {
    label: 'Helsinki',
    value: 'Helsinki'
  },
  {
    label: 'Hirvensalmi',
    value: 'Hirvensalmi'
  },
  {
    label: 'Hollola',
    value: 'Hollola'
  },
  {
    label: 'Huittinen',
    value: 'Huittinen'
  },
  {
    label: 'Humppila',
    value: 'Humppila'
  },
  {
    label: 'Hyrynsalmi',
    value: 'Hyrynsalmi'
  },
  {
    label: 'Hyvinkää',
    value: 'Hyvinkää'
  },
  {
    label: 'Hämeenkyrö',
    value: 'Hämeenkyrö'
  },
  {
    label: 'Hämeenlinna',
    value: 'Hämeenlinna'
  },
  {
    label: 'Ii',
    value: 'Ii'
  },
  {
    label: 'Iisalmi',
    value: 'Iisalmi'
  },
  {
    label: 'Iitti',
    value: 'Iitti'
  },
  {
    label: 'Ikaalinen',
    value: 'Ikaalinen'
  },
  {
    label: 'Ilmajoki',
    value: 'Ilmajoki'
  },
  {
    label: 'Ilomantsi',
    value: 'Ilomantsi'
  },
  {
    label: 'Imatra',
    value: 'Imatra'
  },
  {
    label: 'Inari',
    value: 'Inari'
  },
  {
    label: 'Inkoo',
    value: 'Inkoo'
  },
  {
    label: 'Isojoki',
    value: 'Isojoki'
  },
  {
    label: 'Isokyrö',
    value: 'Isokyrö'
  },
  {
    label: 'Janakkala',
    value: 'Janakkala'
  },
  {
    label: 'Joensuu',
    value: 'Joensuu'
  },
  {
    label: 'Jokioinen',
    value: 'Jokioinen'
  },
  {
    label: 'Jomala',
    value: 'Jomala'
  },
  {
    label: 'Joroinen',
    value: 'Joroinen'
  },
  {
    label: 'Joutsa',
    value: 'Joutsa'
  },
  {
    label: 'Juuka',
    value: 'Juuka'
  },
  {
    label: 'Juupajoki',
    value: 'Juupajoki'
  },
  {
    label: 'Juva',
    value: 'Juva'
  },
  {
    label: 'Jyväskylä',
    value: 'Jyväskylä'
  },
  {
    label: 'Jämijärvi',
    value: 'Jämijärvi'
  },
  {
    label: 'Jämsä',
    value: 'Jämsä'
  },
  {
    label: 'Järvenpää',
    value: 'Järvenpää'
  },
  {
    label: 'Kaarina',
    value: 'Kaarina'
  },
  {
    label: 'Kaavi',
    value: 'Kaavi'
  },
  {
    label: 'Kajaani',
    value: 'Kajaani'
  },
  {
    label: 'Kalajoki',
    value: 'Kalajoki'
  },
  {
    label: 'Kangasala',
    value: 'Kangasala'
  },
  {
    label: 'Kangasniemi',
    value: 'Kangasniemi'
  },
  {
    label: 'Kankaanpää',
    value: 'Kankaanpää'
  },
  {
    label: 'Kannonkoski',
    value: 'Kannonkoski'
  },
  {
    label: 'Kannus',
    value: 'Kannus'
  },
  {
    label: 'Karijoki',
    value: 'Karijoki'
  },
  {
    label: 'Karkkila',
    value: 'Karkkila'
  },
  {
    label: 'Karstula',
    value: 'Karstula'
  },
  {
    label: 'Karvia',
    value: 'Karvia'
  },
  {
    label: 'Kaskinen',
    value: 'Kaskinen'
  },
  {
    label: 'Kauhajoki',
    value: 'Kauhajoki'
  },
  {
    label: 'Kauhava',
    value: 'Kauhava'
  },
  {
    label: 'Kauniainen',
    value: 'Kauniainen'
  },
  {
    label: 'Kaustinen',
    value: 'Kaustinen'
  },
  {
    label: 'Keitele',
    value: 'Keitele'
  },
  {
    label: 'Kemi',
    value: 'Kemi'
  },
  {
    label: 'Kemijärvi',
    value: 'Kemijärvi'
  },
  {
    label: 'Keminmaa',
    value: 'Keminmaa'
  },
  {
    label: 'Kemiönsaari',
    value: 'Kemiönsaari'
  },
  {
    label: 'Kempele',
    value: 'Kempele'
  },
  {
    label: 'Kerava',
    value: 'Kerava'
  },
  {
    label: 'Keuruu',
    value: 'Keuruu'
  },
  {
    label: 'Kihniö',
    value: 'Kihniö'
  },
  {
    label: 'Kinnula',
    value: 'Kinnula'
  },
  {
    label: 'Kirkkonummi',
    value: 'Kirkkonummi'
  },
  {
    label: 'Kitee',
    value: 'Kitee'
  },
  {
    label: 'Kittilä',
    value: 'Kittilä'
  },
  {
    label: 'Kiuruvesi',
    value: 'Kiuruvesi'
  },
  {
    label: 'Kivijärvi',
    value: 'Kivijärvi'
  },
  {
    label: 'Kokemäki',
    value: 'Kokemäki'
  },
  {
    label: 'Kokkola',
    value: 'Kokkola'
  },
  {
    label: 'Kolari',
    value: 'Kolari'
  },
  {
    label: 'Konnevesi',
    value: 'Konnevesi'
  },
  {
    label: 'Kontiolahti',
    value: 'Kontiolahti'
  },
  {
    label: 'Korsnäs',
    value: 'Korsnäs'
  },
  {
    label: 'Koski Tl',
    value: 'Koski Tl'
  },
  {
    label: 'Kotka',
    value: 'Kotka'
  },
  {
    label: 'Kouvola',
    value: 'Kouvola'
  },
  {
    label: 'Kristiinankaupunki',
    value: 'Kristiinankaupunki'
  },
  {
    label: 'Kruunupyy',
    value: 'Kruunupyy'
  },
  {
    label: 'Kuhmo',
    value: 'Kuhmo'
  },
  {
    label: 'Kuhmoinen',
    value: 'Kuhmoinen'
  },
  {
    label: 'Kumlinge',
    value: 'Kumlinge'
  },
  {
    label: 'Kuopio',
    value: 'Kuopio'
  },
  {
    label: 'Kuortane',
    value: 'Kuortane'
  },
  {
    label: 'Kurikka',
    value: 'Kurikka'
  },
  {
    label: 'Kustavi',
    value: 'Kustavi'
  },
  {
    label: 'Kuusamo',
    value: 'Kuusamo'
  },
  {
    label: 'Kyyjärvi',
    value: 'Kyyjärvi'
  },
  {
    label: 'Kärkölä',
    value: 'Kärkölä'
  },
  {
    label: 'Kärsämäki',
    value: 'Kärsämäki'
  },
  {
    label: 'Kökar',
    value: 'Kökar'
  },
  {
    label: 'Lahti',
    value: 'Lahti'
  },
  {
    label: 'Laihia',
    value: 'Laihia'
  },
  {
    label: 'Laitila',
    value: 'Laitila'
  },
  {
    label: 'Lapinjärvi',
    value: 'Lapinjärvi'
  },
  {
    label: 'Lapinlahti',
    value: 'Lapinlahti'
  },
  {
    label: 'Lappajärvi',
    value: 'Lappajärvi'
  },
  {
    label: 'Lappeenranta',
    value: 'Lappeenranta'
  },
  {
    label: 'Lapua',
    value: 'Lapua'
  },
  {
    label: 'Laukaa',
    value: 'Laukaa'
  },
  {
    label: 'Lemi',
    value: 'Lemi'
  },
  {
    label: 'Lemland',
    value: 'Lemland'
  },
  {
    label: 'Lempäälä',
    value: 'Lempäälä'
  },
  {
    label: 'Leppävirta',
    value: 'Leppävirta'
  },
  {
    label: 'Lestijärvi',
    value: 'Lestijärvi'
  },
  {
    label: 'Lieksa',
    value: 'Lieksa'
  },
  {
    label: 'Lieto',
    value: 'Lieto'
  },
  {
    label: 'Liminka',
    value: 'Liminka'
  },
  {
    label: 'Liperi',
    value: 'Liperi'
  },
  {
    label: 'Lohja',
    value: 'Lohja'
  },
  {
    label: 'Loimaa',
    value: 'Loimaa'
  },
  {
    label: 'Loppi',
    value: 'Loppi'
  },
  {
    label: 'Loviisa',
    value: 'Loviisa'
  },
  {
    label: 'Luhanka',
    value: 'Luhanka'
  },
  {
    label: 'Lumijoki',
    value: 'Lumijoki'
  },
  {
    label: 'Lumparland',
    value: 'Lumparland'
  },
  {
    label: 'Luoto',
    value: 'Luoto'
  },
  {
    label: 'Luumäki',
    value: 'Luumäki'
  },
  {
    label: 'Maalahti',
    value: 'Maalahti'
  },
  {
    label: 'Maarianhamina',
    value: 'Maarianhamina'
  },
  {
    label: 'Marttila',
    value: 'Marttila'
  },
  {
    label: 'Masku',
    value: 'Masku'
  },
  {
    label: 'Merijärvi',
    value: 'Merijärvi'
  },
  {
    label: 'Merikarvia',
    value: 'Merikarvia'
  },
  {
    label: 'Miehikkälä',
    value: 'Miehikkälä'
  },
  {
    label: 'Mikkeli',
    value: 'Mikkeli'
  },
  {
    label: 'Muhos',
    value: 'Muhos'
  },
  {
    label: 'Multia',
    value: 'Multia'
  },
  {
    label: 'Muonio',
    value: 'Muonio'
  },
  {
    label: 'Mustasaari',
    value: 'Mustasaari'
  },
  {
    label: 'Muurame',
    value: 'Muurame'
  },
  {
    label: 'Mynämäki',
    value: 'Mynämäki'
  },
  {
    label: 'Myrskylä',
    value: 'Myrskylä'
  },
  {
    label: 'Mäntsälä',
    value: 'Mäntsälä'
  },
  {
    label: 'Mänttä-Vilppula',
    value: 'Mänttä-Vilppula'
  },
  {
    label: 'Mäntyharju',
    value: 'Mäntyharju'
  },
  {
    label: 'Naantali',
    value: 'Naantali'
  },
  {
    label: 'Nakkila',
    value: 'Nakkila'
  },
  {
    label: 'Nivala',
    value: 'Nivala'
  },
  {
    label: 'Nokia',
    value: 'Nokia'
  },
  {
    label: 'Nousiainen',
    value: 'Nousiainen'
  },
  {
    label: 'Nurmes',
    value: 'Nurmes'
  },
  {
    label: 'Nurmijärvi',
    value: 'Nurmijärvi'
  },
  {
    label: 'Närpiö',
    value: 'Närpiö'
  },
  {
    label: 'Orimattila',
    value: 'Orimattila'
  },
  {
    label: 'Oripää',
    value: 'Oripää'
  },
  {
    label: 'Orivesi',
    value: 'Orivesi'
  },
  {
    label: 'Oulainen',
    value: 'Oulainen'
  },
  {
    label: 'Oulu',
    value: 'Oulu'
  },
  {
    label: 'Outokumpu',
    value: 'Outokumpu'
  },
  {
    label: 'Padasjoki',
    value: 'Padasjoki'
  },
  {
    label: 'Paimio',
    value: 'Paimio'
  },
  {
    label: 'Paltamo',
    value: 'Paltamo'
  },
  {
    label: 'Parainen',
    value: 'Parainen'
  },
  {
    label: 'Parikkala',
    value: 'Parikkala'
  },
  {
    label: 'Parkano',
    value: 'Parkano'
  },
  {
    label: 'Pedersöre',
    value: 'Pedersöre'
  },
  {
    label: 'Pelkosenniemi',
    value: 'Pelkosenniemi'
  },
  {
    label: 'Pello',
    value: 'Pello'
  },
  {
    label: 'Perho',
    value: 'Perho'
  },
  {
    label: 'Petäjävesi',
    value: 'Petäjävesi'
  },
  {
    label: 'Pieksämäki',
    value: 'Pieksämäki'
  },
  {
    label: 'Pielavesi',
    value: 'Pielavesi'
  },
  {
    label: 'Pietarsaari',
    value: 'Pietarsaari'
  },
  {
    label: 'Pihtipudas',
    value: 'Pihtipudas'
  },
  {
    label: 'Pirkkala',
    value: 'Pirkkala'
  },
  {
    label: 'Polvijärvi',
    value: 'Polvijärvi'
  },
  {
    label: 'Pomarkku',
    value: 'Pomarkku'
  },
  {
    label: 'Pori',
    value: 'Pori'
  },
  {
    label: 'Pornainen',
    value: 'Pornainen'
  },
  {
    label: 'Porvoo',
    value: 'Porvoo'
  },
  {
    label: 'Posio',
    value: 'Posio'
  },
  {
    label: 'Pudasjärvi',
    value: 'Pudasjärvi'
  },
  {
    label: 'Pukkila',
    value: 'Pukkila'
  },
  {
    label: 'Punkalaidun',
    value: 'Punkalaidun'
  },
  {
    label: 'Puolanka',
    value: 'Puolanka'
  },
  {
    label: 'Puumala',
    value: 'Puumala'
  },
  {
    label: 'Pyhtää',
    value: 'Pyhtää'
  },
  {
    label: 'Pyhäjoki',
    value: 'Pyhäjoki'
  },
  {
    label: 'Pyhäjärvi',
    value: 'Pyhäjärvi'
  },
  {
    label: 'Pyhäntä',
    value: 'Pyhäntä'
  },
  {
    label: 'Pyhäranta',
    value: 'Pyhäranta'
  },
  {
    label: 'Pälkäne',
    value: 'Pälkäne'
  },
  {
    label: 'Pöytyä',
    value: 'Pöytyä'
  },
  {
    label: 'Raahe',
    value: 'Raahe'
  },
  {
    label: 'Raasepori',
    value: 'Raasepori'
  },
  {
    label: 'Raisio',
    value: 'Raisio'
  },
  {
    label: 'Rantasalmi',
    value: 'Rantasalmi'
  },
  {
    label: 'Ranua',
    value: 'Ranua'
  },
  {
    label: 'Rauma',
    value: 'Rauma'
  },
  {
    label: 'Rautalampi',
    value: 'Rautalampi'
  },
  {
    label: 'Rautavaara',
    value: 'Rautavaara'
  },
  {
    label: 'Rautjärvi',
    value: 'Rautjärvi'
  },
  {
    label: 'Reisjärvi',
    value: 'Reisjärvi'
  },
  {
    label: 'Riihimäki',
    value: 'Riihimäki'
  },
  {
    label: 'Ristijärvi',
    value: 'Ristijärvi'
  },
  {
    label: 'Rovaniemi',
    value: 'Rovaniemi'
  },
  {
    label: 'Ruokolahti',
    value: 'Ruokolahti'
  },
  {
    label: 'Ruovesi',
    value: 'Ruovesi'
  },
  {
    label: 'Rusko',
    value: 'Rusko'
  },
  {
    label: 'Rääkkylä',
    value: 'Rääkkylä'
  },
  {
    label: 'Saarijärvi',
    value: 'Saarijärvi'
  },
  {
    label: 'Salla',
    value: 'Salla'
  },
  {
    label: 'Salo',
    value: 'Salo'
  },
  {
    label: 'Saltvik',
    value: 'Saltvik'
  },
  {
    label: 'Sastamala',
    value: 'Sastamala'
  },
  {
    label: 'Sauvo',
    value: 'Sauvo'
  },
  {
    label: 'Savitaipale',
    value: 'Savitaipale'
  },
  {
    label: 'Savonlinna',
    value: 'Savonlinna'
  },
  {
    label: 'Savukoski',
    value: 'Savukoski'
  },
  {
    label: 'Seinäjoki',
    value: 'Seinäjoki'
  },
  {
    label: 'Sievi',
    value: 'Sievi'
  },
  {
    label: 'Siikainen',
    value: 'Siikainen'
  },
  {
    label: 'Siikajoki',
    value: 'Siikajoki'
  },
  {
    label: 'Siikalatva',
    value: 'Siikalatva'
  },
  {
    label: 'Siilinjärvi',
    value: 'Siilinjärvi'
  },
  {
    label: 'Simo',
    value: 'Simo'
  },
  {
    label: 'Sipoo',
    value: 'Sipoo'
  },
  {
    label: 'Siuntio',
    value: 'Siuntio'
  },
  {
    label: 'Sodankylä',
    value: 'Sodankylä'
  },
  {
    label: 'Soini',
    value: 'Soini'
  },
  {
    label: 'Somero',
    value: 'Somero'
  },
  {
    label: 'Sonkajärvi',
    value: 'Sonkajärvi'
  },
  {
    label: 'Sotkamo',
    value: 'Sotkamo'
  },
  {
    label: 'Sottunga',
    value: 'Sottunga'
  },
  {
    label: 'Sulkava',
    value: 'Sulkava'
  },
  {
    label: 'Sund',
    value: 'Sund'
  },
  {
    label: 'Suomussalmi',
    value: 'Suomussalmi'
  },
  {
    label: 'Suonenjoki',
    value: 'Suonenjoki'
  },
  {
    label: 'Sysmä',
    value: 'Sysmä'
  },
  {
    label: 'Säkylä',
    value: 'Säkylä'
  },
  {
    label: 'Taipalsaari',
    value: 'Taipalsaari'
  },
  {
    label: 'Taivalkoski',
    value: 'Taivalkoski'
  },
  {
    label: 'Taivassalo',
    value: 'Taivassalo'
  },
  {
    label: 'Tammela',
    value: 'Tammela'
  },
  {
    label: 'Tampere',
    value: 'Tampere'
  },
  {
    label: 'Tervo',
    value: 'Tervo'
  },
  {
    label: 'Tervola',
    value: 'Tervola'
  },
  {
    label: 'Teuva',
    value: 'Teuva'
  },
  {
    label: 'Tohmajärvi',
    value: 'Tohmajärvi'
  },
  {
    label: 'Toholampi',
    value: 'Toholampi'
  },
  {
    label: 'Toivakka',
    value: 'Toivakka'
  },
  {
    label: 'Tornio',
    value: 'Tornio'
  },
  {
    label: 'Turku',
    value: 'Turku'
  },
  {
    label: 'Tuusniemi',
    value: 'Tuusniemi'
  },
  {
    label: 'Tuusula',
    value: 'Tuusula'
  },
  {
    label: 'Tyrnävä',
    value: 'Tyrnävä'
  },
  {
    label: 'Ulvila',
    value: 'Ulvila'
  },
  {
    label: 'Urjala',
    value: 'Urjala'
  },
  {
    label: 'Utajärvi',
    value: 'Utajärvi'
  },
  {
    label: 'Utsjoki',
    value: 'Utsjoki'
  },
  {
    label: 'Uurainen',
    value: 'Uurainen'
  },
  {
    label: 'Uusikaarlepyy',
    value: 'Uusikaarlepyy'
  },
  {
    label: 'Uusikaupunki',
    value: 'Uusikaupunki'
  },
  {
    label: 'Vaala',
    value: 'Vaala'
  },
  {
    label: 'Vaasa',
    value: 'Vaasa'
  },
  {
    label: 'Valkeakoski',
    value: 'Valkeakoski'
  },
  {
    label: 'Vantaa',
    value: 'Vantaa'
  },
  {
    label: 'Varkaus',
    value: 'Varkaus'
  },
  {
    label: 'Vehmaa',
    value: 'Vehmaa'
  },
  {
    label: 'Vesanto',
    value: 'Vesanto'
  },
  {
    label: 'Vesilahti',
    value: 'Vesilahti'
  },
  {
    label: 'Veteli',
    value: 'Veteli'
  },
  {
    label: 'Vieremä',
    value: 'Vieremä'
  },
  {
    label: 'Vihti',
    value: 'Vihti'
  },
  {
    label: 'Viitasaari',
    value: 'Viitasaari'
  },
  {
    label: 'Vimpeli',
    value: 'Vimpeli'
  },
  {
    label: 'Virolahti',
    value: 'Virolahti'
  },
  {
    label: 'Virrat',
    value: 'Virrat'
  },
  {
    label: 'Vårdö',
    value: 'Vårdö'
  },
  {
    label: 'Vöyri',
    value: 'Vöyri'
  },
  {
    label: 'Ylitornio',
    value: 'Ylitornio'
  },
  {
    label: 'Ylivieska',
    value: 'Ylivieska'
  },
  {
    label: 'Ylöjärvi',
    value: 'Ylöjärvi'
  },
  {
    label: 'Ypäjä',
    value: 'Ypäjä'
  },
  {
    label: 'Ähtäri',
    value: 'Ähtäri'
  },
  {
    label: 'Äänekoski',
    value: 'Äänekoski'
  }
]

/** Case-insensitive lookup of a municipality option by name */
const findCityOption = (name?: string) => {
  const normalized = name?.trim().toLowerCase()
  return normalized
    ? arrayOfCities.find((city) => city.value.toLowerCase() === normalized)
    : undefined
}

/** Stored postal area as a form value: the matching option, else the raw value so validation flags it */
const getPostalAreaInitialValue = (postalArea?: string) =>
  findCityOption(postalArea) || postalArea || undefined

export { arrayOfCities, findCityOption, getPostalAreaInitialValue }
